jQuery(document).ready(function($) {

    isSmallMobile = {
        any: function() {
            return $(window).width() < 767;
        }
    };

    // Mobile Footer Menus
    if ($(window).width() <= 768) {
        $('.linkWrapper__widgets .widget').on('click', function() {
            $(this).toggleClass('active').siblings().removeClass('active');
            $(this).find(' > div').slideToggle().parent().siblings().find(' > div').slideUp();
        });
    }

    // Place Homepage only Javascript inside of IF statement
    // if (document.body.classList.contains('home')) {
    // 
    // }

});